import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const WideArrowUpward = _ref => {
  let {
    width = 24,
    height = 24,
    className = '',
    fill = 'currentColor'
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.0001 15C17.7664 15.0005 17.54 14.9191 17.3601 14.77L12.0001 10.29L6.6301 14.61C6.20137 14.9582 5.57159 14.8929 5.22343 14.4642C5.22231 14.4628 5.2212 14.4614 5.2201 14.46H5.2201C4.87194 14.0313 4.93725 13.4015 5.36597 13.0534C5.36735 13.0523 5.36872 13.0511 5.3701 13.05L11.3701 8.22004V8.22004C11.7391 7.91672 12.2711 7.91672 12.6401 8.22004L18.6401 13.22C19.0653 13.5725 19.1242 14.2029 18.7717 14.6281C18.7712 14.6288 18.7706 14.6294 18.7701 14.63C18.5817 14.8623 18.2992 14.9981 18.0001 15V15Z"
    })
  });
};